'use strict';

/**
 *
 * @name: ngFocus
 *
 */

function NgFocusDirective() {

  'ngInject';

  var FOCUS_CLASS = 'ng-focused';

  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, element, attrs, ctrl) {

      ctrl.$focused = false;

      element
        .bind('focus', function() {

          element.addClass(FOCUS_CLASS);

          scope.$apply(function() {

            ctrl.$focused = true;
          });
        })
        .bind('blur', function() {

          element.removeClass(FOCUS_CLASS);

          scope.$apply(function() {

            ctrl.$focused = false;
          });
        });
    }
  };
}

export default NgFocusDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/ng-focus.directive.js